export default [
    {
        name: "console",
        type: "gltfLoader",
        path: "/model/gameboy-new1.glb"
    },
    {
        name: "grill",
        type: "texture",
        path: "/textures/grill.jpg"
    },
    {
        name: "weird",
        type: "texture",
        path: "/textures/weird.jpg"
    },
    {
        name: "font2",
        type: "font",
        path: "/fonts/Pixellari_Medium.json"
    },
    {
        name: "space",
        type: "texture",
        path: "/textures/space.png"
    },
    {
        name: "selector",
        type: "texture",
        path: "/textures/selector.png"
    },
    {
        name: "stickingTogether",
        type: "texture",
        path: "/textures/stickingTogether.png"
    },
    {
        name: "gloppyTheSlime",
        type: "texture",
        path: "/textures/gloppyTheSlime.png"
    },
    {
        name: "lorenzAttractor",
        type: "texture",
        path: "/textures/lorenzAttractor.png"
    },
    {
        name: "rayMarching2D",
        type: "texture",
        path: "/textures/rayMarching2D.png"
    },
    {
        name: "sierpinskiTriangle",
        type: "texture",
        path: "/textures/sierpinskiTriangle.png"
    },
    {
        name: "flowfield",
        type: "texture",
        path: "/textures/flowfield.png"
    },
    {
        name: "deloitte",
        type: "texture",
        path: "/textures/deloitte.jpg"
    },
    {
        name: "mail",
        type: "texture",
        path: "/textures/mail.jpg"
    },
    {
        name: "github",
        type: "texture",
        path: "/textures/github.jpg"
    },
    {
        name: "a",
        type: "texture",
        path: "/textures/a.png"
    },
    {
        name: "roughness",
        type: "texture",
        path: "/textures/roughness.jpg"
    },
    {
        name: "normal",
        type: "texture",
        path: "/textures/normal.png"
    },
    {
        name: "b",
        type: "texture",
        path: "/textures/b.png"
    },
    {
        name: "dpad",
        type: "texture",
        path: "/textures/dpad.png"
    },
    {
        name: "esc",
        type: "texture",
        path: "/textures/esc.png"
    },
    {
        name: "ws",
        type: "texture",
        path: "/textures/ws.png"
    },
    {
        name: "cibo",
        type: "texture",
        path: "/textures/cibo.png"
    },
    {
        name: "itch",
        type: "texture",
        path: "/textures/itch.png"
    },
    {
        name: "resume",
        type: "texture",
        path: "/textures/resume.png"
    },
    {
        name: "hoverSound",
        type: "audio",
        path: "/sounds/hover.wav"
    },
    {
        name: "selectedSound",
        type: "audio",
        path: "/sounds/selected.wav"
    },
    {
        name: "backSound",
        type: "audio",
        path: "/sounds/hover2.wav"
    }
]